import { render } from "./Main.vue?vue&type=template&id=0e9b61ec"
const script = {}
script.render = render

export default script